import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import FHIR from 'fhirclient'
import FhirClient from 'fhirclient/lib/FhirClient';
import { AuthService } from '../shared/auth/auth.service'; // Adjust path as needed

@Component({
  selector: 'app-launch',
  imports: [CommonModule],
  templateUrl: './launch.component.html',
  styleUrl: './launch.component.scss'
})
export class LaunchComponent {
  private authService = inject(AuthService);
  private http = inject(HttpClient);

  private fhirBaseUrl = 'http://localhost:5289/fhir';

  practitionerData: any = null;
  loading = false;
  error: string | null = null;

  ngOnInit(): void {
    // 🔍 LOG SESSION DATA
    const session = this.authService.getSession();
    console.log('📦 Current Session Data:', session);
    console.log('📦 Full Session (formatted):', JSON.stringify(session, null, 2));

    if (session) {
      console.log('   User ID:', session.userId);
      console.log('   Email:', session.workEmail);
      console.log('   Name:', session.name);
      console.log('   Role:', session.role);
      console.log('   Organization ID:', session.organizationId);
      console.log('   Hospital ID:', session.hospitalId);
      console.log('   FHIR Resource ID:', session.fhirResourceId);
      console.log('   Is Super Admin:', session.isSuperAdmin);
    } else {
      console.log('⚠️ No active session found');
    }

    // Fetch FHIR Practitioner data
    this.fetchPractitionerData();

    // USE window.location.origin + '/auth/callback',
    // but force it to start with https
    let origin = window.location.origin;
    if (origin.startsWith("http://")) {
      origin = origin.replace("http://", "https://");
    }

    FHIR.oauth2.authorize({
      clientId: 'aca0e463-0e12-4f03-b353-7f8cc7a39d36',
      scope: 'fhirUser',
      redirectUri: origin + '/auth/callback',
      iss: 'https://elikita-server.daalitech.com',
      pkceMode: 'unsafeV1',
    }).then((client) => {
      console.log('FHIR client authorized:', client);
      client = (client + "").replace("http://", "https://");
      console.log('Redirecting to client URL:', client);
      // window.location.href = client + "";
    }).catch((error) => {
      setTimeout(() => {
        // window.location.reload();
      }, 3000);
      console.error('Error during FHIR client authorization:', error);
    });
  }

  /**
   * Fetch Practitioner data from FHIR server
   */
fetchPractitionerData  (): void {
    const url = `${this.fhirBaseUrl}/Practitioner?_format=json`;
    console.log('🔗 Fetching from:', url);

    this.loading = true;
    this.error = null;

    this.http.get(url).subscribe({
      next: (data) => {
        this.practitionerData = data;
        this.loading = false;
        console.log('✅ Practitioner Data:', data);
        console.log('📋 Formatted:', JSON.stringify(data, null, 2));
      },
      error: (error) => {
        this.error = error.message || 'Failed to fetch practitioner data';
        this.loading = false;
        console.error('❌ Error fetching practitioner data:', error);
      }
    });
  }

  /**
   * Fetch specific practitioner by ID
   */
  fetchPractitionerById(id: string): void {
    const url = `${this.fhirBaseUrl}/Practitioner/${id}?_format=json`;
    console.log('🔗 Fetching specific practitioner from:', url);

    this.loading = true;
    this.error = null;

    this.http.get(url).subscribe({
      next: (data) => {
        this.practitionerData = data;
        this.loading = false;
        console.log('✅ Specific Practitioner Data:', data);
        console.log('📋 Formatted:', JSON.stringify(data, null, 2));
      },
      error: (error) => {
        this.error = error.message || 'Failed to fetch practitioner';
        this.loading = false;
        console.error('❌ Error fetching specific practitioner:', error);
      }
    });
  }

  /**
   * Fetch practitioner based on current session
   */
  fetchCurrentUserPractitioner(): void {
    const session = this.authService.getSession();

    if (session?.fhirResourceId && session.role === 'Practitioner') {
      this.fetchPractitionerById(session.fhirResourceId);
    } else {
      this.fetchPractitionerData();
    }
  }
}
